export enum Direction {
	TopToBottom = 'TB',
	LeftToRight = 'LR',
}
